// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let ReactRelay = require("react-relay");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let DevicePixelRatio = require("../v5/common/DevicePixelRatio.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");

function makeRefetchVariables(after, areaIds, before, buyerNeedPropertyTypes, buyerNeedStatuses, first, keywords, last, maxPrice, minPrice, rentalMode, rentalNeedPropertyTypes, rentalNeedStatuses) {
  return {
    after: after,
    areaIds: areaIds,
    before: before,
    buyerNeedPropertyTypes: buyerNeedPropertyTypes,
    buyerNeedStatuses: buyerNeedStatuses,
    first: first,
    keywords: keywords,
    last: last,
    maxPrice: maxPrice,
    minPrice: minPrice,
    rentalMode: rentalMode,
    rentalNeedPropertyTypes: rentalNeedPropertyTypes,
    rentalNeedStatuses: rentalNeedStatuses
  };
}

let Types = {
  makeRefetchVariables: makeRefetchVariables
};

let variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"":{"f":""}}};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, undefined, null);
}

let responseConverter = {"__root":{"":{"f":""}}};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, undefined, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: undefined,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: undefined,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

function buyerNeedV5FilterableStatus_decode($$enum) {
  if ($$enum === "ACTIVE" || $$enum === "WITHDRAWN" || $$enum === "EXPIRED" || $$enum === "PURCHASED" || $$enum === "IN_CONTRACT") {
    return $$enum;
  }
}

let buyerNeedV5FilterableStatus_fromString = buyerNeedV5FilterableStatus_decode;

function forSalePropertyTypeEnumV5_decode($$enum) {
  if ($$enum === "CONDO" || $$enum === "SINGLE_FAMILY" || $$enum === "LOT" || $$enum === "MULTI_UNIT") {
    return $$enum;
  }
}

let forSalePropertyTypeEnumV5_fromString = forSalePropertyTypeEnumV5_decode;

function rentalNeedV5FilterableStatus_decode($$enum) {
  if ($$enum === "ACTIVE" || $$enum === "WITHDRAWN" || $$enum === "EXPIRED" || $$enum === "RENTED") {
    return $$enum;
  }
}

let rentalNeedV5FilterableStatus_fromString = rentalNeedV5FilterableStatus_decode;

function rentalPropertyTypeEnumV5_decode($$enum) {
  if ($$enum === "CONDO" || $$enum === "SINGLE_FAMILY") {
    return $$enum;
  }
}

let rentalPropertyTypeEnumV5_fromString = rentalPropertyTypeEnumV5_decode;

let Utils = {
  buyerNeedV5FilterableStatus_decode: buyerNeedV5FilterableStatus_decode,
  buyerNeedV5FilterableStatus_fromString: buyerNeedV5FilterableStatus_fromString,
  forSalePropertyTypeEnumV5_decode: forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: forSalePropertyTypeEnumV5_fromString,
  rentalNeedV5FilterableStatus_decode: rentalNeedV5FilterableStatus_decode,
  rentalNeedV5FilterableStatus_fromString: rentalNeedV5FilterableStatus_fromString,
  rentalPropertyTypeEnumV5_decode: rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: rentalPropertyTypeEnumV5_fromString
};

let providedVariablesDefinition = {
  __relay_internal__pv__DevicePixelRatio: {
    providedVariable: DevicePixelRatio.get,
    get: DevicePixelRatio.get
  }
};

function makeNode(providedVariablesDefinition) {
  return ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "areaIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "buyerNeedPropertyTypes"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "buyerNeedStatuses"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "keywords"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "maxPrice"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "minPrice"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rentalMode"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rentalNeedPropertyTypes"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rentalNeedStatuses"
},
v13 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v14 = {
  "kind": "Variable",
  "name": "before",
  "variableName": "before"
},
v15 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v16 = {
  "kind": "Variable",
  "name": "last",
  "variableName": "last"
},
v17 = [
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/)
],
v18 = {
  "kind": "Variable",
  "name": "areaIds",
  "variableName": "areaIds"
},
v19 = {
  "kind": "Variable",
  "name": "keywords",
  "variableName": "keywords"
},
v20 = {
  "kind": "Variable",
  "name": "maxPrice",
  "variableName": "maxPrice"
},
v21 = {
  "kind": "Variable",
  "name": "minPrice",
  "variableName": "minPrice"
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPreviousPage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startCursor",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headline",
  "storageKey": null
},
v26 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "format",
        "value": "SHORT"
      }
    ],
    "kind": "ScalarField",
    "name": "formatted",
    "storageKey": "formatted(format:\"SHORT\")"
  }
],
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "PriceRange",
  "kind": "LinkedField",
  "name": "priceRange",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Price",
      "kind": "LinkedField",
      "name": "minPrice",
      "plural": false,
      "selections": (v26/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Price",
      "kind": "LinkedField",
      "name": "maxPrice",
      "plural": false,
      "selections": (v26/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v29 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Area",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v24/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "label",
        "storageKey": null
      },
      (v28/*: any*/)
    ],
    "storageKey": null
  }
],
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v31 = [
  (v30/*: any*/)
],
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minBeds",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v35 = {
  "kind": "Variable",
  "name": "ratio",
  "variableName": "__relay_internal__pv__DevicePixelRatio"
},
v36 = {
  "kind": "Literal",
  "name": "width",
  "value": 60
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "Agent",
  "kind": "LinkedField",
  "name": "agent",
  "plural": false,
  "selections": [
    (v24/*: any*/),
    (v30/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "brokerage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProfilePhoto",
      "kind": "LinkedField",
      "name": "profilePhoto",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            (v35/*: any*/),
            (v36/*: any*/)
          ],
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": "urlWithRing",
          "args": [
            (v35/*: any*/),
            {
              "kind": "Literal",
              "name": "ring",
              "value": true
            },
            (v36/*: any*/)
          ],
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "membershipStatus",
      "storageKey": null
    },
    (v28/*: any*/)
  ],
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v39 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v40 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "broadcastAt",
    "storageKey": null
  },
  (v28/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientNeedsPageRelayQuery",
    "selections": [
      {
        "args": (v17/*: any*/),
        "kind": "FragmentSpread",
        "name": "ClientNeedsPageRelayBuying_query"
      },
      {
        "args": (v17/*: any*/),
        "kind": "FragmentSpread",
        "name": "ClientNeedsPageRelayRental_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v7/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v10/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__DevicePixelRatio"
      }
    ],
    "kind": "Operation",
    "name": "ClientNeedsPageRelayQuery",
    "selections": [
      {
        "condition": "rentalMode",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": [
              (v13/*: any*/),
              (v18/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v19/*: any*/),
              (v16/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              {
                "kind": "Variable",
                "name": "propertyTypes",
                "variableName": "buyerNeedPropertyTypes"
              },
              {
                "kind": "Variable",
                "name": "statuses",
                "variableName": "buyerNeedStatuses"
              }
            ],
            "concreteType": "BuyerNeedV5Connection",
            "kind": "LinkedField",
            "name": "searchBuyerNeeds",
            "plural": false,
            "selections": [
              (v22/*: any*/),
              (v23/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BuyerNeedV5Edge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BuyerNeedV5",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v24/*: any*/),
                      (v25/*: any*/),
                      (v27/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BuyerNeedAreaConnection",
                        "kind": "LinkedField",
                        "name": "areas",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BuyerNeedAreaEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": (v29/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BuyerNeedPropertyType",
                        "kind": "LinkedField",
                        "name": "propertyTypes",
                        "plural": true,
                        "selections": (v31/*: any*/),
                        "storageKey": null
                      },
                      (v32/*: any*/),
                      (v33/*: any*/),
                      (v34/*: any*/),
                      (v37/*: any*/),
                      (v38/*: any*/),
                      {
                        "alias": null,
                        "args": (v39/*: any*/),
                        "concreteType": "BuyerNeedBroadcastConnection",
                        "kind": "LinkedField",
                        "name": "broadcasts",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BuyerNeedBroadcastEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "BuyerNeedBroadcast",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v40/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "broadcasts(first:1)"
                      },
                      (v28/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "condition": "rentalMode",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": [
              (v13/*: any*/),
              (v18/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v19/*: any*/),
              (v16/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              {
                "kind": "Variable",
                "name": "propertyTypes",
                "variableName": "rentalNeedPropertyTypes"
              },
              {
                "kind": "Variable",
                "name": "statuses",
                "variableName": "rentalNeedStatuses"
              }
            ],
            "concreteType": "RentalNeedV5Connection",
            "kind": "LinkedField",
            "name": "searchRentalNeeds",
            "plural": false,
            "selections": [
              (v22/*: any*/),
              (v23/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RentalNeedV5Edge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RentalNeedV5",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v24/*: any*/),
                      (v25/*: any*/),
                      (v27/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RentalNeedAreaConnection",
                        "kind": "LinkedField",
                        "name": "areas",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RentalNeedAreaEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": (v29/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RentalNeedPropertyType",
                        "kind": "LinkedField",
                        "name": "propertyTypes",
                        "plural": true,
                        "selections": (v31/*: any*/),
                        "storageKey": null
                      },
                      (v32/*: any*/),
                      (v33/*: any*/),
                      (v34/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "availableFrom",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LeaseLengthV5",
                        "kind": "LinkedField",
                        "name": "leaseLength",
                        "plural": false,
                        "selections": (v31/*: any*/),
                        "storageKey": null
                      },
                      (v37/*: any*/),
                      (v38/*: any*/),
                      {
                        "alias": null,
                        "args": (v39/*: any*/),
                        "concreteType": "RentalNeedBroadcastConnection",
                        "kind": "LinkedField",
                        "name": "broadcasts",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RentalNeedBroadcastEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RentalNeedBroadcast",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v40/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "broadcasts(first:1)"
                      },
                      (v28/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "14c11cc8e415bff7f0c53653f9848ae9",
    "id": null,
    "metadata": {},
    "name": "ClientNeedsPageRelayQuery",
    "operationKind": "query",
    "text": "query ClientNeedsPageRelayQuery(\n  $areaIds: [ID!]\n  $buyerNeedPropertyTypes: [ForSalePropertyTypeEnumV5!]\n  $buyerNeedStatuses: [BuyerNeedV5FilterableStatus!]\n  $rentalNeedPropertyTypes: [RentalPropertyTypeEnumV5!]\n  $rentalNeedStatuses: [RentalNeedV5FilterableStatus!]\n  $maxPrice: Int\n  $minPrice: Int\n  $keywords: [String!]\n  $first: Int\n  $last: Int\n  $before: String\n  $after: String\n  $rentalMode: Boolean!\n  $__relay_internal__pv__DevicePixelRatio: Float!\n) {\n  ...ClientNeedsPageRelayBuying_query_pbnwq\n  ...ClientNeedsPageRelayRental_query_pbnwq\n}\n\nfragment AgentInfo_agent on Agent {\n  id\n  displayName\n  brokerage\n  profilePhoto {\n    url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio)\n    urlWithRing: url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio, ring: true)\n  }\n  membershipStatus\n}\n\nfragment AreasCriteria_area on Area {\n  id\n  name\n  label\n}\n\nfragment BuyerNeedAddedDate_buyerNeedV5 on BuyerNeedV5 {\n  createdAt\n}\n\nfragment BuyerNeedAreas_buyerNeedV5 on BuyerNeedV5 {\n  areas {\n    edges {\n      node {\n        ...AreasCriteria_area\n        nodeId\n      }\n    }\n  }\n}\n\nfragment BuyerNeedPropertyAttributes_buyerNeedV5 on BuyerNeedV5 {\n  propertyTypes {\n    ...BuyerNeedPropertyAttributes_propertyTypes\n  }\n  minBeds\n}\n\nfragment BuyerNeedPropertyAttributes_propertyTypes on BuyerNeedPropertyType {\n  displayName\n}\n\nfragment BuyerNeedSearchResultTimestamp_buyerNeed on BuyerNeedV5 {\n  updatedAt\n  broadcasts(first: 1) {\n    edges {\n      node {\n        broadcastAt\n        nodeId\n      }\n    }\n  }\n}\n\nfragment BuyerNeedSearchResult_buyerNeed on BuyerNeedV5 {\n  id\n  headline\n  ...PriceRangeCriteriaBuyerNeed_buyerNeedV5\n  ...BuyerNeedAreas_buyerNeedV5\n  ...BuyerNeedPropertyAttributes_buyerNeedV5\n  ...BuyerNeedAddedDate_buyerNeedV5\n  ...BuyerNeedStatus_buyerNeedV5\n  agent {\n    ...AgentInfo_agent\n    nodeId\n  }\n  ...BuyerNeedSearchResultTimestamp_buyerNeed\n}\n\nfragment BuyerNeedStatus_buyerNeedV5 on BuyerNeedV5 {\n  status {\n    __typename\n    ... on ActiveBuyerNeed {\n      __typename\n    }\n    ... on ExpiredBuyerNeed {\n      __typename\n    }\n    ... on InContractBuyerNeed {\n      __typename\n    }\n    ... on PurchasedBuyerNeed {\n      __typename\n    }\n    ... on WithdrawnBuyerNeed {\n      __typename\n    }\n  }\n}\n\nfragment ClientNeedsPageRelayBuying_query_pbnwq on Query {\n  searchBuyerNeeds(areaIds: $areaIds, propertyTypes: $buyerNeedPropertyTypes, statuses: $buyerNeedStatuses, maxPrice: $maxPrice, minPrice: $minPrice, first: $first, after: $after, before: $before, last: $last, keywords: $keywords) @skip(if: $rentalMode) {\n    pageInfo {\n      hasNextPage\n      endCursor\n      hasPreviousPage\n      startCursor\n    }\n    totalCount\n    edges {\n      node {\n        id\n        ...BuyerNeedSearchResult_buyerNeed\n        nodeId\n      }\n    }\n  }\n}\n\nfragment ClientNeedsPageRelayRental_query_pbnwq on Query {\n  searchRentalNeeds(areaIds: $areaIds, propertyTypes: $rentalNeedPropertyTypes, statuses: $rentalNeedStatuses, maxPrice: $maxPrice, minPrice: $minPrice, first: $first, after: $after, before: $before, last: $last, keywords: $keywords) @include(if: $rentalMode) {\n    pageInfo {\n      hasNextPage\n      endCursor\n      hasPreviousPage\n      startCursor\n    }\n    totalCount\n    edges {\n      node {\n        id\n        ...RentalNeedSearchResult_rentalNeed\n        nodeId\n      }\n    }\n  }\n}\n\nfragment PriceRangeCriteriaBuyerNeed_buyerNeedV5 on BuyerNeedV5 {\n  priceRange {\n    ...PriceRangeCriteria_priceRange\n  }\n}\n\nfragment PriceRangeCriteriaRentalNeed_rentalNeedV5 on RentalNeedV5 {\n  priceRange {\n    ...PriceRangeCriteria_priceRange\n  }\n}\n\nfragment PriceRangeCriteria_priceRange on PriceRange {\n  minPrice {\n    formatted(format: SHORT)\n  }\n  maxPrice {\n    formatted(format: SHORT)\n  }\n}\n\nfragment RentalNeedAddedDate_rentalNeedV5 on RentalNeedV5 {\n  createdAt\n}\n\nfragment RentalNeedAreas_rentalNeedV5 on RentalNeedV5 {\n  areas {\n    edges {\n      node {\n        ...AreasCriteria_area\n        nodeId\n      }\n    }\n  }\n}\n\nfragment RentalNeedLeaseAttributes_rentalNeedV5 on RentalNeedV5 {\n  availableFrom\n  leaseLength {\n    displayName\n  }\n}\n\nfragment RentalNeedPropertyAttributes_rentalNeedV5 on RentalNeedV5 {\n  propertyTypes {\n    displayName\n  }\n  minBeds\n}\n\nfragment RentalNeedSearchResultTimestamp_rentalNeed on RentalNeedV5 {\n  updatedAt\n  broadcasts(first: 1) {\n    edges {\n      node {\n        broadcastAt\n        nodeId\n      }\n    }\n  }\n}\n\nfragment RentalNeedSearchResult_rentalNeed on RentalNeedV5 {\n  id\n  headline\n  ...PriceRangeCriteriaRentalNeed_rentalNeedV5\n  ...RentalNeedAreas_rentalNeedV5\n  ...RentalNeedPropertyAttributes_rentalNeedV5\n  ...RentalNeedAddedDate_rentalNeedV5\n  ...RentalNeedStatus_rentalNeedV5\n  ...RentalNeedLeaseAttributes_rentalNeedV5\n  agent {\n    ...AgentInfo_agent\n    nodeId\n  }\n  ...RentalNeedSearchResultTimestamp_rentalNeed\n}\n\nfragment RentalNeedStatus_rentalNeedV5 on RentalNeedV5 {\n  status {\n    __typename\n    ... on ActiveRentalNeed {\n      __typename\n    }\n    ... on ExpiredRentalNeed {\n      __typename\n    }\n    ... on RentedRentalNeed {\n      __typename\n    }\n    ... on WithdrawnRentalNeed {\n      __typename\n    }\n    ... on RemovedRentalNeed {\n      __typename\n    }\n  }\n}\n",
    "providedVariables": providedVariablesDefinition
  }
};
})());
}

let node = makeNode(providedVariablesDefinition);

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
    fetchKey: fetchKey,
    fetchPolicy: fetchPolicy,
    networkCacheConfig: networkCacheConfig
  });
}

function queryRefToObservable(token) {
  return Primitive_option.fromNullable(token.source);
}

function queryRefToPromise(token) {
  return new Promise((resolve, _reject) => {
    let o = queryRefToObservable(token);
    if (o !== undefined) {
      Primitive_option.valFromOption(o).subscribe({
        complete: () => resolve({
          TAG: "Ok",
          _0: undefined
        })
      });
      return;
    } else {
      return resolve({
        TAG: "Error",
        _0: undefined
      });
    }
  });
}

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.providedVariablesDefinition = providedVariablesDefinition;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
